import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DatePickerComponent } from '../../../../common/datepicker/datepicker.component';
import * as moment from 'moment';
import { getProfAmount, getCommissionAmount } from "../../../../globals";
import { SettingsService } from '../../../../injections/settings.service';
import { ServiceService } from '../../../../injections/service.service';

@Component({
  selector: 'service-data',
  templateUrl: '../../templates/partials/data-service.html'
})
export class DataServiceComponent implements OnInit{

    @Input() editData: boolean = false;
    @Input() service;
    @Output() updateEmitter = new EventEmitter();
    @Output() discountEmitter = new EventEmitter();
    public serviceData: FormGroup;
    public parsedPeriodicity: string;
    public serviceCopy;
    public applyDiscount: boolean = false;
    public dt;
    public opened = false;
    public comissions;
    public buttonSaveDisabled = false;
    public discount = {
        discountCode: '',
        discountType: '',
        discountValue: '',
        buttonDisabled: true,
        codeDisabled: false,
        valueDisabled: false,
        errorDiscountCode: false
    }
    @ViewChild(DatePickerComponent) datepicker: DatePickerComponent

    constructor(private _fb: FormBuilder, private settingsService: SettingsService, private serviceService: ServiceService){
        this.settingsService.getComissions().subscribe(result => {
            this.comissions = result;
        });
    }

    public toggleDataEdit(){
        var date = moment(this.service["date"],"DD/MM/YYYY").format("llll");
        this.serviceCopy = Object.assign({}, this.service);
        this.serviceData = this._fb.group({
            date: [this.service["date"], [Validators.required]],
            hour: [this.service["time_ini"], [Validators.required]],
            duration: [this.service["n_hours"], [Validators.required]],
            periodicity: [this.service["periodicity"], [Validators.required]]
        });
        this.setInitialPrices();
        this.parsePeriodicity();
        this.editData = (this.editData) ? false : true;

    }

    public showDiscountForm(){
        this.applyDiscount = true;
    }

    public closeDatePicker($event) {
        if($event.relatedTarget == null || $event.relatedTarget.type == "text" ){
            this.opened = false;
        }
    }

    public openDatePicker(){
        this.opened = true;
    }

    public updateData() { 
        let data = this.parseServiceToUpdate();
        //console.log(data);
        this.updateEmitter.emit(data);
    }

    public setInitialPrices() {
        this.setInitialAmounts();
    }

    public onChangeDuration(event){
        this.serviceCopy["n_hours"] = parseFloat(event);
        this.setAmounts();
    }

    public changePrice(increment: string){
        if(this.serviceCopy["hour_price"] > 7){
            this.serviceCopy["hour_price"] = parseFloat(this.serviceCopy["hour_price"]);
            if(increment == "minus"){
                this.serviceCopy["hour_price"] -= 0.05;
            }else{
                this.serviceCopy["hour_price"] += 0.05;
            }
            this.setAmounts();
            
            let indexNew: any = parseFloat(this.serviceCopy["hour_price"]);
            indexNew = indexNew.toFixed(2);
            let newService_C = this.comissions[indexNew];
            this.buttonSaveDisabled = (newService_C == null) ? true : false;
        }
    }

    private setAmounts() {
        var n_hours: any = this.serviceCopy["n_hours"];
        var hour_price = parseFloat(this.serviceCopy["hour_price"]);
        var fee = parseFloat(this.serviceCopy["fee"]);
        var hoursAmount = (hour_price * n_hours);

        if(typeof this.serviceCopy["hour_price"] != 'string'){
            this.serviceCopy["hour_price"] = this.serviceCopy["hour_price"].toFixed(2);
        }
        var products = (this.serviceCopy["with_products"] == 0) ? 0 : 2;
        var transport = parseFloat(this.serviceCopy["transport_amount"]);
    
        var subtotal = hoursAmount + products + transport;
        var subtotalFee = (hoursAmount + fee) + products + transport;
        var discountA = this.getDiscountImport(subtotal);
        var totalReal = subtotal - discountA;

        this.serviceCopy["hours_amount"] = hoursAmount.toFixed(2);
        this.serviceCopy["subtotal_amount"] = subtotal.toFixed(2);
        this.serviceCopy["subtotal_amount_present"] = subtotalFee.toFixed(2);
        this.serviceCopy["total_amount"] = (subtotal).toFixed(2);
        this.serviceCopy["total_amount_real"] = (totalReal).toFixed(2);
        this.serviceCopy["total_amount_present"] = (subtotalFee - discountA).toFixed(2);
    }

    private getDiscountImport(subtotal: number){
        let discountAmount = 0;
        if(this.serviceCopy["discount_amount"] != 0){
            discountAmount = parseFloat(this.serviceCopy["discount_amount"]);
        }else if(this.serviceCopy["discount_hours_amount"] != 0){
            discountAmount = this.serviceCopy["hour_price"] * parseFloat(this.serviceCopy["discount_hours_amount"]);
        }else if(this.serviceCopy["discount_percent_amount"] != 0){
            var discountPercent = parseFloat(this.serviceCopy["discount_percent_amount"]) / 100;
            discountAmount = subtotal * discountPercent;
        }
        return discountAmount;
    }

    private setInitialAmounts() {
        var n_hours = parseFloat(this.serviceCopy["n_hours"]);
        var hour_price = parseFloat(this.serviceCopy["hour_price"]);
        var hoursAmount = (hour_price * n_hours);
        var fee = parseFloat(this.serviceCopy["fee"]);
        var subtotal = this.serviceCopy["total_amount"];
        var subtotalFee = parseFloat(this.serviceCopy["total_amount"]) + fee;
        this.serviceCopy["hours_amount"] = hoursAmount.toFixed(2);
        this.service["hours_amount"] = hoursAmount.toFixed(2);
        this.service["hours_amount_real"] = hoursAmount.toFixed(2);
        this.serviceCopy["subtotal_amount"] = subtotal;
        this.service["subtotal_amount"] = this.serviceCopy["subtotal_amount"];
        this.service["subtotal_amount_real"] = this.serviceCopy["subtotal_amount"];
        this.serviceCopy["subtotal_amount_present"] = subtotalFee.toFixed(2);
    }

    public onChangeTimeIni(event){
        this.serviceCopy["time_ini"] = event;
    }

    public dateChange(event){
        this.opened = false;
    }

    public getDate() {
      if(this.dt != null){
        return moment(this.dt).format("DD/MM/YYYY");
      }
      return '';

    }

    public setProducts(value: number) {
        this.serviceCopy["with_products"] = value;
        this.setAmounts();
    }
    
    public setPayment(type: string) {
        this.serviceCopy["payment_method"] = type;
    }

    public parsePeriodicity(){
        if(this.service["periodicity"] != null){
            switch(this.service["periodicity"]){
                case "none":  this.parsedPeriodicity = "Servicio Puntual";
                break;

                case "1-week":  this.parsedPeriodicity = "Servicio Semanal";
                break;

                case "2-week":  this.parsedPeriodicity = "Servicio Quincenal";
                break;
            }
        }
    }

    public changeDiscountField(event) {
        this.discount.buttonDisabled = ((this.discount.discountType != '' && this.discount.discountValue != '') || this.discount.discountCode != '') ? false : true;
        this.discount.valueDisabled = (this.discount.discountCode.length > 0) ? true : false;
        this.discount.codeDisabled = (this.discount.discountValue.length > 0 || this.discount.discountType.length > 0) ? true : false;
    }

    public setDiscount() {

        if(!this.discount.buttonDisabled) this.getDiscountData(this.discount.discountType || "code") || {};
    }

    private getDiscountData(type: string) {
        let data;
        this.discount.errorDiscountCode = false;
        this.discount.buttonDisabled = true;
        if(type != "code"){
            var amount = parseFloat(this.discount.discountValue);
            amount = (type == "percent") ? amount / 100 : amount;
            let object = {
                totalAmountReal: null,
                discountAmount: null
            };
            this.getTotalAmountRealDiscount(amount, object);
            let commission_amount = this.getCommissionDiscount(object.discountAmount || amount);
            data = {
                type: this.discount.discountType,
                value: this.discount.discountValue,
                commissionAmount: parseFloat(commission_amount.toFixed(2)),
                subTotalAmount: parseFloat(object.totalAmountReal.toFixed(2)),
                totalAmountReal: parseFloat(object.totalAmountReal.toFixed(2))
            }
            this.discountEmitter.emit({type: this.discount.discountType, data: data});
        }else{
            this.serviceService.checkDiscount(this.service["client_mail"], this.discount.discountCode).subscribe(result => {
                if(result["status"] == "OK"){
                    var amount = parseFloat(result["data"]["discount_amount"]);
                    amount = (result["data"]["discount_type"] == "percent") ? amount / 100 : amount;
                    let object = {
                        totalAmountReal: null,
                        discountAmount: null
                    };
                    this.getTotalAmountRealDiscount(amount, object, result["data"]["discount_type"]);
                    let commission_amount = this.getCommissionDiscount(object.discountAmount || amount);
                    amount = (result["data"]["discount_type"] == "percent") ? amount * 100 : amount;
                    data = {
                        type: result["data"]["discount_type"],
                        value: amount.toFixed(2),
                        discountCode: result["data"]["code"],
                        commissionAmount: parseFloat(commission_amount.toFixed(2)),
                        subTotalAmount: parseFloat(object.totalAmountReal.toFixed(2)),
                        totalAmountReal: parseFloat(object.totalAmountReal)
                    }
                    this.discountEmitter.emit({type: "code", data: data});
                }else{
                    this.discount.errorDiscountCode = true;
                    this.discount.buttonDisabled = false;
                }
            });
        }
    }

    private getTotalAmountRealDiscount(amount, object, type = null) {
        var n_hours = parseFloat(this.service["n_hours"]);
        var hour_price = parseFloat(this.service["hour_price"]);
        var hoursAmount = (hour_price * n_hours);
        var products = (this.service["with_products"] == 1) ? 2 : 0;
        var transport = parseFloat(this.service["transport_amount"]);
        if(this.discount.discountType == "percent" || type == "percent"){
            object.discountAmount = hoursAmount * amount;
            object.totalAmountReal = hoursAmount - object.discountAmount + products + transport;
        }if(this.discount.discountType == "amount" || type == "amount"){
            object.totalAmountReal = hoursAmount - amount + products + transport;
        }
        if(this.discount.discountType == "hours" || type == "hours"){
            amount = amount * hour_price;
            object.totalAmountReal = hoursAmount - amount + products + transport;
        }
    }

    private getCommissionDiscount(amount) {
        let indexNew: any = parseFloat(this.service["hour_price"]);
        indexNew = indexNew.toFixed(2);
        let commissionObj = this.comissions[indexNew];
        let commission_amount = getCommissionAmount(this.service, commissionObj["benefit"]);

        commission_amount = commission_amount - amount;
        commission_amount = (commission_amount < 0) ? 0 : commission_amount;

        return commission_amount;
    }

    public checkDiscount() {
        this.discountEmitter.emit({type: "check", data: this.discount.discountCode});
    }

    private parseServiceToUpdate() {
        let indexOld: any = parseFloat(this.service["hour_price"]);
        indexOld = indexOld.toFixed(2);
        let indexNew: any = parseFloat(this.serviceCopy["hour_price"]);
        indexNew = indexNew.toFixed(2);
        let oldService_C = this.comissions[indexOld];
        let newService_C = this.comissions[indexNew];
        let n_hours = parseFloat(this.service["n_hours"]);
        let n_hours_copy = parseFloat(this.serviceCopy["n_hours"]);
        let comission_amountOld = getCommissionAmount(this.service, oldService_C["benefit"]);
        let comission_amountNew = getCommissionAmount(this.serviceCopy, newService_C["benefit"]);
        let profHourOld = oldService_C["cleaner"];
        let profHourNew = newService_C["cleaner"];
        let profAmountOld = getProfAmount(this.service, profHourOld);
        let profAmountNew = getProfAmount(this.serviceCopy, profHourOld);
        
        this.serviceCopy["date"] = this.datepicker.formatDate;
        this.serviceCopy["periodicity"] = this.serviceData.controls.periodicity.value;
        this.serviceCopy["time_end"] = this.getTimeEnd();

        let oldService = {
            date: moment(this.service["date"], "DD/MM/YYYY").format("YYYY-MM-DD"),
            time_ini_real: this.service["time_ini"],
            time_end_real: this.service["time_end"],
            time_ini: this.service["time_ini"],
            time_end: this.service["time_end"],
            n_hours_real: n_hours,
            n_hours: n_hours,
            with_products: this.service["with_products"],
            with_products_real: this.service["with_products"],
            hours_amount: this.service["hours_amount"],
            hours_amount_real: this.service["hours_amount"],
            products_amount_real: (this.service["with_products"] == 0) ? "0" : "2",
            products_amount: (this.service["with_products"] == 0) ? "0" : "2",
            periodicity: this.service["periodicity"],
            payment_method_real: this.service["payment_method"],
            payment_method: this.service["payment_method"],
            hour_price: this.service["hour_price"],
            total_amount_real: this.service["total_amount_real"],
            total_amount: this.service["total_amount"],
            subtotal_amount_real: this.service["subtotal_amount"],
            subtotal_amount: this.service["subtotal_amount"],
            commission_percent: oldService_C["commission"].toString(),
            commission_amount: comission_amountOld.toString(),
            professional_amount: profAmountOld.toString(),
            professional_hour_price: profHourOld.toString(),
            discount_hours_amount: this.service["discount_hours_amount"].toString(),
            discount_amount: this.service["discount_amount"].toString(),
            discount_code: this.service["discount_code"],
            id_professional: this.service["id_professional"]

        }

        let newService = {
            date: moment(this.serviceCopy["date"], "DD/MM/YYYY").format("YYYY-MM-DD"),
            time_ini_real: this.serviceCopy["time_ini"],
            time_end_real: this.serviceCopy["time_end"],
            time_ini: this.serviceCopy["time_ini"],
            time_end: this.serviceCopy["time_end"],
            n_hours_real: n_hours_copy,
            n_hours: n_hours_copy,
            with_products: this.serviceCopy["with_products"],
            with_products_real: this.serviceCopy["with_products"],
            hours_amount: this.serviceCopy["hours_amount"],
            hours_amount_real: this.serviceCopy["hours_amount"],
            products_amount_real: (this.serviceCopy["with_products"] == 0) ? "0" : "2",
            products_amount: (this.serviceCopy["with_products"] == 0) ? "0" : "2",
            periodicity: this.serviceCopy["periodicity"],
            payment_method_real: this.serviceCopy["payment_method"],
            payment_method: this.serviceCopy["payment_method"],
            hour_price: this.serviceCopy["hour_price"],
            total_amount_real: this.serviceCopy["total_amount_real"],
            total_amount: this.serviceCopy["total_amount"],
            subtotal_amount_real: this.serviceCopy["subtotal_amount"],
            subtotal_amount: this.serviceCopy["subtotal_amount"],
            commission_percent: oldService_C["commission"].toString(),
            commission_amount: comission_amountOld.toString(),
            professional_amount: profAmountNew.toString(),
            professional_hour_price: profHourOld.toString(),
            discount_hours_amount: this.serviceCopy["discount_hours_amount"].toString(),
            discount_amount: this.serviceCopy["discount_amount"].toString(),
            discount_code: this.serviceCopy["discount_code"],
            id_professional: 0
        }

        if(oldService["discount_code"] == "" || oldService["discount_code"] == null){
            delete oldService["discount_code"];
            delete oldService["discount_amount"];
            delete oldService["discount_hours_amount"];
            delete newService["discount_code"];
            delete newService["discount_amount"];
            delete newService["discount_hours_amount"];
        }

        let data = {
            old_service: oldService,
            new_service: newService
        }
        return data;
    }

    private getTimeEnd(){
        var time = moment(this.serviceCopy["time_ini"],"HH:mm");
        time.add()
        var date = moment();
        var time_end = date.set({hour: time.get("hour"), minute: time.get("minute")});
        var n_hours = parseFloat(this.serviceCopy["n_hours"]);
        time_end.add(n_hours,"hours");

        return time_end.format("HH:mm");
    }

    ngOnInit() {
        this.serviceData = this._fb.group({
            date: ['', [Validators.required]],
            hour: ['', [Validators.required]],
            duration: ['', [Validators.required]],
            periodicity: ['', [Validators.required]],
        });
        
    }  
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/data-service.component.ts